import axios from "axios";

export const state = {
    user_roles: [],
    user_saving: false,
    all_users: [],
    role_permissions: {},
    admin_user: ''
};
export const getters = {
    CLINIC_USERS: state => state.all_users.data,
    ROLES: state => state.user_roles.data,
    RolePermissions: state => state.role_permissions,
    USER_SAVING: state => state.user_saving,
    GetAdminUser: state => state.admin_user,
};

export const mutations = {
    SET_USERS: (state, newValue) => state.all_users = newValue,
    SET_USER_ROLES: (state, newValue) => state.user_roles = newValue,
    SET_ADMIN_USER: (state, newValue) => state.admin_user = newValue,
    SET_USER_STATUS: (state, newValue) => state.user_saving = newValue,
    SET_ROLE_PERMISSIONS: (state, newValue) => state.role_permissions = newValue,
    EMPTY_ROLE_PERMISSIONS: (state) => state.role_permissions = {},
};
export const actions = {
    addUserRole({ commit, dispatch }, payload) {
        commit('SET_USER_STATUS', true);
        axios.post('add_role', payload).then(() => {
            dispatch('fetchUserRoles');
            let message = { 'msg': "User Role added successfully" }
            // DISPATCH MESSAGE MODULE
            dispatch('notification/success', message, { root: true })
            commit('SET_USER_STATUS', false);
        }).catch((err) => {
            commit('SET_USER_STATUS', false)
            let message = { 'msg': err.response.data.msg }
            dispatch('notification/error', message, { root: true })
        })
    },
    // Edit User Role
    editUserRole({ commit, dispatch }, payload) {
        commit('SET_USER_STATUS', true);
        axios.post(`edit_role`, payload).then(() => {
            dispatch('fetchUserRoles');
            let message = { 'msg': "User Role updated successfully" }
            // DISPATCH MESSAGE MODULE
            dispatch('notification/success', message, { root: true })
            commit('SET_USER_STATUS', false);
        }).catch(() => {
            commit('SET_USER_STATUS', false)
            let message = { 'msg': "Error updating User Role" }
            dispatch('notification/error', message, { root: true })
        })
    },
    // Delete User Role
    deleteUserRole({ commit, dispatch }, payload) {
        // console.log(payload);
        commit('SET_USER_STATUS', true);
        axios.delete(`delete_role/${payload.id}`).then(() => {
            dispatch('fetchUserRoles');
            let message = { 'msg': "User Role deleted successfully" }
            // DISPATCH MESSAGE MODULE
            dispatch('notification/success', message, { root: true })
            commit('SET_USER_STATUS', false);
        }).catch(() => {
            commit('SET_USER_STATUS', false)
            let message = { 'msg': "Error deleting User Role" }
            dispatch('notification/error', message, { root: true })
        })
    },

    // Delete User Role
    deleteUser({ commit, dispatch }, payload) {
        // console.log(payload);
        commit('SET_USER_STATUS', true);
        axios.delete(`delete_user/${payload.id}`).then(() => {
            dispatch('fetchUsers');
            let message = { 'msg': "User deleted successfully" }
            // DISPATCH MESSAGE MODULE
            dispatch('notification/success', message, { root: true })
            commit('SET_USER_STATUS', false);
        }).catch(() => {
            commit('SET_USER_STATUS', false)
            let message = { 'msg': "Error deleting User" }
            dispatch('notification/error', message, { root: true })
        })
    },

    // Edit User Role
    editUser({ commit, dispatch }, payload) {
        commit('SET_USER_STATUS', true);
        axios.post(`edit_user_role`, payload).then(() => {
            dispatch('fetchUsers');
            let message = { 'msg': "User Role updated successfully" }
            // DISPATCH MESSAGE MODULE
            dispatch('notification/success', message, { root: true })
            commit('SET_USER_STATUS', false);
        }).catch(() => {
            commit('SET_USER_STATUS', false)
            let message = { 'msg': "Error updating User Role" }
            dispatch('notification/error', message, { root: true })
        })
    },

    // Suspend User Role
    suspendUser({ commit, dispatch }, payload) {
        commit('SET_USER_STATUS', true);
        axios.post(`suspend_user`, payload).then(() => {
            dispatch('fetchUsers');
            let message = { 'msg': "User Suspended successfully" }
            // DISPATCH MESSAGE MODULE
            dispatch('notification/success', message, { root: true })
            commit('SET_USER_STATUS', false);
        }).catch(() => {
            commit('SET_USER_STATUS', false)
            let message = { 'msg': "Error suspending User" }
            dispatch('notification/error', message, { root: true })
        })
    },

    // Activate User Role
    activateUser({ commit, dispatch }, payload) {
        commit('SET_USER_STATUS', true);
        axios.post(`activate_user`, payload).then(() => {
            dispatch('fetchUsers');
            let message = { 'msg': "User Activated successfully" }
            // DISPATCH MESSAGE MODULE
            dispatch('notification/success', message, { root: true })
            commit('SET_USER_STATUS', false);
        }).catch(() => {
            commit('SET_USER_STATUS', false)
            let message = { 'msg': "Error Activating User" }
            dispatch('notification/error', message, { root: true })
        })
    },

    fetchUsers({ commit }) {
        axios.get('system_users').then(users => {
            commit('SET_USERS', users.data)
        })
    },
    fetchUserRoles({ commit }) {
        axios.get('roles').then(roles => {
            commit('SET_USER_ROLES', roles.data)
        })
    },
    fetchrolepermissionsPre({ commit }, role_id) {
        commit('EMPTY_ROLE_PERMISSIONS')
        axios.get(`permissions/${role_id}`).then(per => {
            commit('SET_ROLE_PERMISSIONS', per.data)
        })
    },
    fetchrolepermissions({ commit }, role_id) {
        axios.get(`permissions/${role_id}`).then(per => {
            commit('SET_ROLE_PERMISSIONS', per.data)
        })
    },
    updateRolePermission({ dispatch }, payload) {
        axios.put(`permissions/${payload.role_id}`, payload).then(() => {
            dispatch('auth/Authenticated_user', null, { root: true })
            dispatch('fetchrolepermissions', payload.role_id)
            let message = { 'msg': "Action successfull" }
            // DISPATCH MESSAGE MODULE
            dispatch('notification/success', message, { root: true })
        }).catch(() => {
            let message = { 'msg': "Error performing action" }
            dispatch('notification/error', message, { root: true })
        })
    },
    fetchAdminUsers({ commit }) {
        axios.get('adminuser').then(roles => {
            commit('SET_ADMIN_USER', roles.data)
        })
    },

};